export default "__VITE_ASSET__JPljViod__"